var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-2"},[_c('app-general-figures')],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('app-general-charts')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }